var StringUtils = {
    // Converted from here: https://github.com/gouch/to-title-case/blob/master/to-title-case.js
    // Using this instead of underscore.string.titleize because it's not smart enuff.
    toTitleCase: function(str) {
        var smallWords = /^(a|am|an|and|as|at|but|by|en|for|if|in|is|nor|of|on|or|per|the|to|vs?\.?|via)$/i;

        str = str.toLowerCase();

        return str.replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(match, index, title) {
            if (
                index > 0 &&
                index + match.length !== title.length &&
                match.search(smallWords) > -1 &&
                title.charAt(index - 2) !== ':' &&
                (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') &&
                title.charAt(index - 1).search(/[^\s-]/) < 0
            ) {
                return match.toLowerCase();
            }

            if (match.substr(1).search(/[A-Z]|\../) > -1) {
                return match;
            }

            return match.charAt(0).toUpperCase() + match.substr(1);
        });
    },

    // Takes a string and returns the initials based on words in string
    initials: function(str, glue) {
        if (typeof glue == 'undefined') {
            var glue = true;
        }

        var initials = str.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g);

        if (!initials) {
            return '';
        }

        if (glue) {
            return initials.join('');
        }

        return initials;
    },

    firstNameAndInitial: function(str) {
        var split = str.trim().split(/\s+/);
        if (split.length > 1) {
            return split[0] + ' ' + split[1][0];
        } else if (split.length === 1) {
            return split[0];
        } else {
            return '';
        }
    },

    toClassName: function(str) {
        return str
            .replace(/ /g, '-') // replace all spaces with hyphens
            .replace(/[\-]+/g, '-') // replace repeating hyphens with single hyphen
            .replace(/[^\w-:]/g, '') // replace all non-alpha chars excluding hyphen with empty str
            .toLowerCase(); // lowercase the result
    },

    toNumberWithOrdinal: function(n) {
        var s = ['th', 'st', 'nd', 'rd'],
            v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    },

    makeCommaSeparatedString: function(arr) {
        const listStart = arr.slice(0, -1).join(', ');
        const listEnd = arr.slice(-1);
        const conjunction = arr.length <= 1 ? '' : ' and ';
        return [listStart, listEnd].join(conjunction);
    },

    getNumberFromCurrency: function(currency) {
        return Number(currency.replace(/[$,]/g, ''));
    },

    capitalizeFirstLetterOfEachWord: function(sentence) {
        const words = sentence.split(' ');

        const capitalizedWords = words.map(word => {
            return word.charAt(0).toUpperCase() + word.slice(1);
        });

        return capitalizedWords.join(' ');
    },

    capitalizeFirstLetter: function(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    },
};

module.exports = StringUtils;
